import { FIELD_TYPES } from "../../widgets/fields";

export const FormElements = {
  queryRadioButtons: {
    name: "queryradiobuttons",
    placeholder: "",
    label: "",
    type: FIELD_TYPES.RADIO_BUTTON,
  },
  titleSearch: {
    name: "titlesearch",
    placeholder: "Search Title",
    label: "Title",
    type: FIELD_TYPES.TEXT,
  },
  authorSearch: {
    name: "authorsearch",
    placeholder: "Search Author",
    label: "Author",
    type: FIELD_TYPES.TEXT,
  },
  sourceDropdown: {
    name: "sourcedropdown",
    placeholder: "Select Source",
    label: "Source",
    type: FIELD_TYPES.DROP_DOWN,
    values: [
      { label: "All", value: "all" },
      { label: "PubMed", value: "pubmed" },
      { label: "Google Scholar", value: "googleScholar" },
      { label: "Crossref", value: "Crossref" },
      { label: "DOAJ", value: "DOAJ" },
    ],
  },
  sortByDropdown: {
    name: "sortbydropdown",
    placeholder: "Sort By",
    label: "Sort By",
    type: FIELD_TYPES.DROP_DOWN,
    values: [
      { label: "None", value: "none"},
      { label: "Most Recent", value: "mostRecent" },
      { label: "Least Recent", value: "leastRecent" },
      { label: "Most Relevant", value: "mostRelevant" },
      { label: "Least Relevant", value: "leastRelevant" },
    ],
  },
}